import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { LocaleState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors((state: RootState): LocaleState => state.locale);

export default selectors;
